import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ALL_ROUTES } from '@/Router';
import './NotFound.scss';

/**
 * NotFound - 404 Page Not Found
 *
 * Design:
 * - Consistent with app design system
 * - Centered layout with message
 * - Navigation buttons to home and back
 */
export const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="not-found">
      <div className="not-found__container">
        <div className="not-found__content">
          <h1 className="not-found__code">404</h1>
          <h2 className="not-found__title">{t('pages.notFound.title')}</h2>
          <p className="not-found__description">{t('pages.notFound.description')}</p>

          <div className="not-found__actions">
            <button
              className="not-found__button not-found__button--primary"
              onClick={() => navigate(ALL_ROUTES.basePath)}
            >
              {t('pages.notFound.backToHome')}
            </button>
            <button
              className="not-found__button not-found__button--secondary"
              onClick={() => navigate(-1)}
            >
              {t('pages.notFound.goBack')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
